<script lang="ts" setup>
import { Help, useHelp } from '@app/components/help';
import type { Props } from '@app/components/help/types';
import { onMounted } from 'vue';

const {
    setHelpData,
} = useHelp();

const props = defineProps<Props>();

onMounted(() => {
    setHelpData(props);
});

</script>
<template>
    <Help></Help>
</template>
